import { initHeroSlider } from './modules/sliders/hero-slider';

document.addEventListener('DOMContentLoaded', () => {
    initHeroSlider();

    function setFilterParams(tabButton) {
        const link = $(tabButton).closest('.container').find('[class*="__link"] a')[0];
        const categoryId = $(tabButton).data('cat-id');
        const url = new URL(link);
        let filter = '';

        url.search = '';

        if (categoryId) {
            const { searchParams } = url;
            searchParams.append(`type_${categoryId}`, 'Y');
            searchParams.append('set_filter', 'y');

            filter = url.search;
        }

        $(link).attr('href', `${url.pathname}${filter}`);
    }

    function initFilterParams() {
        const categoryLinks = $('.equipment-main, .coffee-main').find('.nav-item');

        $(categoryLinks).each((i, el) => {
            if ($(el).hasClass('active')) {
                setFilterParams(el);
            }

            $(el).on('shown.bs.tab', (e) => {
                setFilterParams(e.target);
            });
        });
    }

    initFilterParams();
});
